import { Plus, X, Crop } from "lucide-react";

// Thumbnails of a document's pages, with an "Add page" tile.
export default function PageStrip({ pages, sel, onSelect, onRemove, onAdd, canAdd }) {
  return (
    <div className="flex gap-3 overflow-x-auto px-1.5 pb-1 pt-2" data-testid="page-strip">
      {pages.map((p, i) => (
        <div key={p.id} className="relative shrink-0">
          <button type="button" onClick={() => onSelect(i)} data-testid={`page-thumb-${i}`}
            className={`flex h-20 w-16 items-center justify-center overflow-hidden rounded-xl border-2 bg-slate-100 transition-colors ${i === sel ? "border-teal-600" : "border-transparent"}`}>
            {p.preview
              ? <img src={p.preview} alt={`Page ${i + 1}`} className="h-full w-full object-cover" style={{ transform: `rotate(${p.rotation}deg)` }} />
              : <span className="text-[10px] font-semibold text-slate-500">PDF</span>}
          </button>
          <span className="absolute bottom-1 left-1 rounded bg-slate-900/80 px-1 text-[10px] font-bold text-white">{i + 1}</span>
          {p.cropped && <Crop className="absolute bottom-1 right-1 h-3.5 w-3.5 rounded bg-white/90 p-0.5 text-teal-700" />}
          {pages.length > 1 && (
            <button type="button" onClick={() => onRemove(i)} aria-label={`Remove page ${i + 1}`} data-testid={`page-remove-${i}`}
              className="absolute -right-1.5 -top-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-rose-600 text-white">
              <X className="h-3 w-3" />
            </button>
          )}
        </div>
      ))}
      {canAdd && (
        <button type="button" onClick={onAdd} data-testid="add-page-button"
          className="flex h-20 w-16 shrink-0 flex-col items-center justify-center gap-1 rounded-xl border-2 border-dashed border-slate-300 text-slate-500 transition-colors hover:border-teal-500 hover:text-teal-700">
          <Plus className="h-4 w-4" /><span className="text-[10px] font-semibold">Add page</span>
        </button>
      )}
    </div>
  );
}
